import type { SceneContent } from '../../presentation/types';

export const sharedDna: SceneContent = {
  id: 'shared-dna',
  shortLabel: 'DNA',
  title: 'Different Products. Same DNA.',
  seconds: 40,
  brand: 'moderta',
  bridgeIn: 'Different products. Now look at what they share.',
  atmosphere: (step) => ({ pattern: step >= 2 ? 'stream' : 'ambient', density: 0.18, opacity: 0.06, cameraZ: 14 }),
  script: (context) => ({
    title: 'Different Products. Same DNA.',
    onScreen: ['DIFFERENT PRODUCTS.', 'SAME DNA.', 'INTELLIGENCE · AUTOMATION · INTEGRATION · DATA · WORKFLOWS · EXPERIENCE · SECURITY', 'Never starting from zero.'],
    visual: `Every enabled product lines up across the top in its group colour${context.isEnabled('mint') ? ', MINT largest with its specialisations under one bracket' : ''}, selected work smallest. A foundation of shared capabilities rises underneath. Every product draws its connections down into the capabilities it is built on, and energy flows through them. A new, unnamed product appears at the end and connects to everything at once.`,
    narration: [
      'Every product here was built for a different problem, for different people.',
      'But underneath, they share the same DNA.',
      'Intelligence, automation, integration, data, workflows, experience and security. Every product is built on the same set of capabilities, and every product strengthens them.',
      'So no product starts from zero. When the next one arrives, most of what it needs already exists.',
    ],
    presenterNotes: [
      'Products line up. "Very different products."',
      'The foundation rises. "Same DNA."',
      'Connections draw down. Name two or three capabilities, not all of them.',
      'The next product connects instantly. "Never starting from zero."',
    ],
  }),
};
